<template>
  <div style="width:100%">
    <el-card>
    <el-card style="background:#feecd0"	>
      <el-row>
        <el-col :span="3">
          <img src="https://www.smsbao.com/resources/shop2/images/icon_news.png" alt="" srcset="">
        </el-col>
        <el-col :span="21">
          <div class="indexcdhd"><span>最新公告</span><el-link href="/xtxx" type="primary" :underline="false" style="float: right">更多</el-link></div>
          <div class="indexcdlr" v-for="(o,i) in gonggao" :key="i">[{{o.nyr}}] <span v-html="o.datalr"></span></div>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin:20px 0;">
      <div style="text-align: center;">
        剩余短信 <span>{{dxpz.dxsyts}}</span> 条 <el-link :underline="false" href="/dxcz"><el-button plain type="primary" size="mini" style="margin-left:10px" >去充值</el-button></el-link>
      </div>
    </el-card>
    <el-card>
      <el-row>
        <el-col :span="24">
          <ve-histogram :data="chartData" :settings="chartSettings" width="100%"></ve-histogram>
        </el-col>
      </el-row>
    </el-card>
    </el-card>
  </div>
</template>

<script>
import config from '../../static/config.json'
import API from '../api/api_user';
export default {
  data () {
    this.chartSettings = {
        labelMap: {
          'rq': '日期',
          'fs': '每日发送数'
        }
      }
    return {
       chartData: {
          columns: ['rq', 'fs'],
          rows: [
           
          ]
        },
        btbt:"每日发送数(20200701-20200715)",
        dxpz:{},
        gonggao:[]
    }
  },
  components: {
      // Top
  },
  created(){
    this.getdxpz();
    this.getmrfs();
    this.getgonggao();
  },
  methods: {
    getgonggao(){
      var that=this;
      var data={lx:'getgonggao',pno:1,pgs:5}
      API.dxjl(data).then(function (result) {
        // format
        if(result.code==200){
         that.gonggao=result.data;
        }else{
            that.$confirm("系统错误,请联系管理员", '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton:false,
            showClose:false,
            center: true
          }).then(() => {
            
          }).catch(() => {
                 
          });
        }
        // //console.log(result)
        
      }, function (err) {
        // //console.log(err)
        that.$message.error({showClose: true, message: err.toString(), duration: 2000});
      }).catch(function (error) {
        // //console.log(error);
        that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
      });
    },
    getdxpz(){
      var that=this;
      var data={lx:'getdxpz'}
      API.dxjl(data).then(function (result) {
        // format
        if(result.code==200){
         result.data=JSON.parse(API.base64decode(result.data));
         that.dxpz=result.data;
        }else{
          that.$confirm("系统错误,请联系管理员", '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton:false,
            showClose:false,
            center: true    
          });
        }
        // //console.log(result)
        
      }, function (err) {
        // //console.log(err)
        that.$message.error({showClose: true, message: err.toString(), duration: 2000});
      }).catch(function (error) {
        // //console.log(error);
        that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
      });
    },
    evlabc(a){//排序大小
      var i =0, j =0, b = 0;
      for (i = 0; i < a.length; i++){
        for (j = 0; j < a.length; j++){
          if (a[i] < a[j]){
            b = a[i];
            a[i] = a[j];
            a[j] = b;
          } 
        }
      }
      return a;
    },
    getmrfs(){
      var arr=API.getJjtDate();
      // //console.log(arr)
      arr=this.evlabc(arr);
      var sj=[]; 
      // //console.log(arr)
      for(var p of arr){
        sj.push({'rq': p, 'fs':0});
      }
      var that=this;
      var data={lx:'getmrfs'}
      API.dxjl(data).then(function (result) {
        // format
        if(result.code==200||result.code==400){
          for(var i=0;i<sj.length;i++){
            for(var p of result.data){
              if(sj[i].rq==p.nyr){
                sj[i].fs=p.fsts
              }
              // sj.push({'日期': p.nyr, '发送量':p.fsts});
            }
            // //console.log(sj)
          }
          that.chartData.rows=sj;
        }else{
          that.chartData.rows=[];
        }
        // //console.log(result)
        
      }, function (err) {
        // //console.log(err)
        that.$message.error({showClose: true, message: err.toString(), duration: 2000});
      }).catch(function (error) {
        // //console.log(error);
        that.$message.error({showClose: true, message: '请求出现异常', duration: 2000});
      });
    },
  },
  computed: {},
  watch: {},
  mounted: function () {
      //只有当组件内容在dom树上挂载完成
      //才能进行dom元素的查找
      //import最顶层，这里不能用
      //import '../assets/js/app.js';
      //require可以使用在任何层次中
      // this.loading=false;
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .indexcdhd{
    border-bottom: 1px solid #29b740;
    height: 30px;
    line-height: 30px;
    width: 100%;
  }
  .indexcdhd span{
    font-size: 14px;
    font-weight: bold;
    color: #666666;
  }
  .indexcdlr{
    overflow: hidden;
    padding: 5px 0;
    height: 26px;
    line-height: 26px;
    font: 12px tahoma, Arial, Verdana, sans-serif;
    color: #666666;
  }
  .indexcdlr span{
    margin-left: 10px;
  }
  .aaa{
    color: green;
    cursor: pointer;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue